"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _context = _interopRequireDefault(require("./context"));

var layerControl = {
  // mounted () {
  //   this.$el && this.$el.setAttribute('h3-layer-control', '');
  // },
  // beforeDestroy () {
  //   this.$el && this.$el.removeAttribute('h3-layer-control');
  // },
  methods: {
    updateZIndex: function updateZIndex(value) {
      if (value === void 0) {
        value = 0;
      }

      this.$el.style.zIndex = ++_context["default"].zIndex + value;
    }
  }
};
var _default = layerControl;
exports["default"] = _default;